module.exports = __webpack_public_path__ + "img/Free Response 01.6efc3656.png";